import styled from "styled-components";

export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: ${({ theme }) => theme.neutral.white};
`;

export const TitleApproval = styled.div`
  color: ${({ theme }) => theme.neutral.gray[2200]};
  font-size: 18px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 25px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
`;

export const ContentSelectors = styled.div`
  width: auto;
  min-height: 240px;
`;

export const ContentUsers = styled.div`
  height: 7em;
  overflow-y: auto;
`;

export const ContentApprovers = styled.div`
  width: auto;
  min-height: 240px;
`;

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 0.5em;
`;

export const ContainerInfoText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
`;

export const ImageApprover = styled.img`
  width: 60%;
  height: 60%;
  border-radius: 50%;
`;

export const ButtonSelectApprover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  width: 154px;
  height: 36px;
  color: ${({ theme }) => theme.neutral.white};
  font-weight: 600;
  font-size: 14px;
  opacity: ${(props) => (props.disabledSelector ? "0.5" : "1")};
  background-color: ${({ theme }) => theme.button.primary};
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ContentActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1em 1rem;
  gap: 10px;
`;

export const ButtonAddApprover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  width: 120px;
  height: 36px;
  color: ${({ theme }) => theme.neutral.white};
  font-weight: 600;
  font-size: 14px;
  opacity: ${(props) => (props.disabledSelector ? "0.5" : "1")};
  background-color: ${({ theme }) => theme.button.primary};
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
